import {useGetActiveBusinessCasesByVehicleQuery, type OfferPriceResponseBody} from '@dms/api/sales';

import type {PurchaseProgress} from '../../model/auctionView';

// The auction sells a vehicle that the dealer buys in an active purchase business case.
export function usePurchaseCase(vehicleId: string) {
  const {data} = useGetActiveBusinessCasesByVehicleQuery({vehicleId});
  return data?.find((businessCase) => businessCase.businessCaseType === 'BUYING') ?? null;
}

export type PurchaseCase = NonNullable<ReturnType<typeof usePurchaseCase>>;

export const purchaseCaseOwner = (purchaseCase: PurchaseCase) =>
  [purchaseCase.createdByFirstName, purchaseCase.createdByLastName].filter(Boolean).join(' ');

const hasPrice = (price: OfferPriceResponseBody | null | undefined) =>
  Boolean(price?.withVat ?? price?.withoutVat);

export const purchaseProgress = (purchaseCase: PurchaseCase | null): PurchaseProgress => {
  if (purchaseCase === null) {
    return null;
  }
  const vehiclePurchase = purchaseCase.vehiclesPurchase[0];
  return {
    hasBuyingLimit: hasPrice(vehiclePurchase?.maxBuyingPrice),
    hasBuyingPrice: hasPrice(vehiclePurchase?.purchasePrice),
  };
};
